import template from './printed-unclosed.html';
import controller from './printed-unclosed.controller';
import './printed-unclosed.scss';

let PrintedUnclosedComponent = {
  bindings: {},
  template,
  controller
};

export default PrintedUnclosedComponent;



// WEBPACK FOOTER //
// ./src/app/pages/printed-unclosed/printed-unclosed.component.js